import {FC, useEffect, useState} from 'react'
import {useLocation, useMatch, useNavigate, useParams} from 'react-router-dom'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Button} from '../../../../components/Button/Button'
import {Input} from '../../../../components/Input/Input'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {i18n} from '../../../../translate/i18n'
import {AdditionalListType} from '../../../../context/additionalContext'
import useAdditional from '../../../../hooks/useAdditional'
import Swal from 'sweetalert2'
import {GET, POST, PUT} from '../../../../services/api'
import {Loading} from '../../../../components/Loading/Loading'

import styles from './create.module.css'
import {DragDropContext, Droppable, Draggable, DropResult} from 'react-beautiful-dnd'
import {floatToPrice} from '../../../../functions/price'
import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../../../hooks/useModals'

type AdditionalType = {
  id: number
  name: string
  code: string
  qtd: number | null
  checked: boolean
}

const EditarOpcionaisContent: FC = () => {
  const navigate = useNavigate()
  const {showWrapperModal} = useModals()
  const {id} = useParams()
  const {getAdditionalIdEditPage} = useAdditional()
  const [productsList, setProductsList] = useState<AdditionalType[]>([])
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [type, setType] = useState('radio')
  const [max, setMax] = useState(0)
  const [required, setRequired] = useState('0')
  const [optionals, setOptionals] = useState<AdditionalType[]>([])
  const [searchOptionals, setSearchOptionals] = useState<AdditionalType[]>([])
  const [loading, setLoading] = useState(false)
  const [query, setQuery] = useState('')
  const [att, setAtt] = useState(false)
  const [idClick, setIdClick] = useState<any | null>(null)

  const getOptionals = async () => {
    try {
      const [res, additionalItemRes] = await Promise.all([
        GET(`/product/optionals`),
        getAdditionalIdEditPage(parseInt(id ? id : '0'))
      ])
      if (res.data && additionalItemRes.success && additionalItemRes.data[0]) {
        const additionalItem: AdditionalListType = additionalItemRes.data[0]
        const newProductList: AdditionalType[] = additionalItem.additionals.filter((add) => add.product).map((add) => ({
          id: add.product.id,
          name: add.product.name,
          code: add.product.code,
          qtd: add.max ? add.max : null,
          checked: false,
        }))
        let newOpts: AdditionalType[] = []
        res.data
        .filter((op: any) => op.status === true)
        .forEach((op: AdditionalType) => {
          if (newProductList.findIndex((p) => p.id === op.id) === -1) {
            newOpts.push({
              id: op.id,
              name: op.name,
              code: op.code,
              qtd: 1,
              checked: false,
            })
          }
        })
        
        setProductsList(newProductList)
        setName(additionalItem.name)
        setDescription(additionalItem.description)
        setType(additionalItem.type)
        setMax(additionalItem.max)
        setRequired(additionalItem.required)
        setOptionals(newOpts)
        setSearchOptionals(newOpts)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const addOptionalItem = () => {
    let newProductsList = [...productsList]
    optionals
      .filter((c) => c.checked && c.checked === true)
      .forEach((c) => {
        c.checked = false
        newProductsList.push({id: c.id, name: c.name, code: c.code, qtd: 1, checked: false})
      })
    const newOptionals = optionals.filter((op) => {
      const indexFinded = newProductsList.findIndex((pd) => pd.id === op.id)
      return indexFinded === -1
    })
    setOptionals(newOptionals)
    setSearchOptionals(newOptionals)
    setProductsList(newProductsList)
  }

  const removeProduct = (product: AdditionalType) => {
    const newOpts = [...optionals]
    newOpts.push(product)
    setOptionals(newOpts)
    setSearchOptionals(newOpts)
    setProductsList(productsList.filter((p) => p.id !== product.id))
  }

  const saveAdditionals = async () => {
    try {
      if (!name) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
      } else {
        setLoading(true)
        const data = {
          name,
          required,
          type,
          max,
          typeoptional: null,
          productId: null,
          description,
          items: productsList.map((pd) => ({id: pd.id, max: pd.qtd ? pd.qtd : null})),
        }
        const res = await PUT(`/optional/additional/${id}`, data)
        if (res && res.success === false) {
          throw new Error()
        }
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Lista atualizada com sucesso!',
        }).then(() => navigate('/optionals'))
      }
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'success',
        title: 'Erro!',
        text: e && typeof e === 'string' ? e : 'Erro ao salvar lista!',
      })
    }
  }

  const onDragEnd = (res: DropResult, list: any, setList: any) => {
    if (!res.destination) return

    const {source, destination} = res
    const copiedItems = [...list]

    const [removed] = copiedItems.splice(source.index, 1)

    copiedItems.splice(destination.index, 0, removed)

    setList(copiedItems)
  }

  const init = async () => {
    setLoading(true)
    await getOptionals()
    setLoading(false)
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    const newSearch = optionals.filter(
      (op) => op.name.toLowerCase().includes(query) || op.code.toLowerCase().includes(query)
    )
    setSearchOptionals(newSearch)
  }, [query])

  useEffect(() => {
    if (att) {
      const updatedOptionals = optionals.map((item) =>
        item.id === idClick ? {...item, checked: false} : item
      )
      setOptionals(updatedOptionals)

      const updatedSearchOptionals = searchOptionals.map((item) =>
        item.id === idClick ? {...item, checked: false} : item
      )
      setSearchOptionals(updatedSearchOptionals)
      setAtt(false)
    }
  }, [att, optionals, searchOptionals, idClick])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`general.edit`)} {i18n.t(`optional.list`).toLowerCase()}
                </span>
              </h3>
            </div>
            <div className='card-body border-bottom'>
              <div className='d-flex flex-row gap-2 align-items-center'>
                <Input
                  inputAttr={{
                    type: 'default',
                  }}
                  placeholder={i18n.t(`optional.name`)}
                  label={i18n.t(`optional.name`)}
                  value={name}
                  change={(value: string) => {
                    setName(value)
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'default',
                  }}
                  placeholder={i18n.t(`optional.description`)}
                  label={i18n.t(`optional.description`)}
                  value={description}
                  change={(value: string) => {
                    setDescription(value)
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'select',
                  }}
                  label={i18n.t(`optional.type`)}
                  options={[
                    {select: 'Seleção única', value: 'radio'},
                    {select: 'Seleção múltipla', value: 'checkbox'},
                    {select: 'Seleção de quantidade', value: 'amount'},
                  ]}
                  value={type}
                  change={(value: string) => {
                    setType(value)
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'select',
                  }}
                  label={i18n.t(`optional.max`)}
                  options={[
                    {select: 'Sem limite', value: 0},
                    {select: '1', value: 1},
                    {select: '2', value: 2},
                    {select: '3', value: 3},
                    {select: '4', value: 4},
                    {select: '5', value: 5},
                    {select: '6', value: 6},
                    {select: '7', value: 7},
                    {select: '8', value: 8},
                    {select: '9', value: 9},
                    {select: '10', value: 10},
                  ]}
                  value={max}
                  change={(value: number) => {
                    setMax(value)
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'select',
                  }}
                  label={i18n.t(`optional.mandatory`)}
                  options={[
                    {select: 'Não', value: '0'},
                    {select: 'Sim', value: '1'},
                  ]}
                  value={required}
                  change={(value: string) => {
                    setRequired(value)
                  }}
                />
              </div>
              {productsList.length > 0 && (
                <div className='d-flex flex-column mt-4'>
                  <span className='card-label fs-3 mb-1'>{i18n.t(`optional.optionals`)}</span>
                  <div className='mt-4 d-flex flex-column'>
                    <div className={`${styles.rowAdditional} ${styles.headerAdditional}`}>
                      <p>{i18n.t('optional.order')}</p>
                      <p>{i18n.t('optional.code')}</p>
                      <p>{i18n.t('optional.name')}</p>
                      <p>{i18n.t('optional.qtd')}</p>
                      <p>{i18n.t('general.actions')}</p>
                    </div>
                    <DragDropContext
                      onDragEnd={(result) => onDragEnd(result, productsList, setProductsList)}
                    >
                      <Droppable droppableId='ROOT' type='group'>
                        {(provided, snapshot) => (
                          <div {...provided.droppableProps} ref={provided.innerRef}>
                            {productsList.map((productListed, index) => (
                              <Draggable
                                key={index.toString()}
                                draggableId={index.toString()}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    className={`${styles.rowAdditional}`}
                                    key={index.toString()}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <svg
                                      width='9'
                                      height='13'
                                      viewBox='0 0 9 13'
                                      fill='none'
                                      xmlns='http://www.w3.org/2000/svg'
                                      style={{cursor: 'pointer'}}
                                    >
                                      <path
                                        d='M1.09375 11.7812H2.40625V10.4688H1.09375V11.7812ZM1.09375 12.875C0.464844 12.875 0 12.4102 0 11.7812V10.4688C0 9.86719 0.464844 9.375 1.09375 9.375H2.40625C3.00781 9.375 3.5 9.86719 3.5 10.4688V11.7812C3.5 12.4102 3.00781 12.875 2.40625 12.875H1.09375ZM6.34375 11.7812H7.65625V10.4688H6.34375V11.7812ZM6.34375 12.875C5.71484 12.875 5.25 12.4102 5.25 11.7812V10.4688C5.25 9.86719 5.71484 9.375 6.34375 9.375H7.65625C8.25781 9.375 8.75 9.86719 8.75 10.4688V11.7812C8.75 12.4102 8.25781 12.875 7.65625 12.875H6.34375ZM1.09375 6.09375V7.40625H2.40625V6.09375H1.09375ZM0 7.40625V6.09375C0 5.49219 0.464844 5 1.09375 5H2.40625C3.00781 5 3.5 5.49219 3.5 6.09375V7.40625C3.5 8.03516 3.00781 8.5 2.40625 8.5H1.09375C0.464844 8.5 0 8.03516 0 7.40625ZM6.34375 7.40625H7.65625V6.09375H6.34375V7.40625ZM6.34375 8.5C5.71484 8.5 5.25 8.03516 5.25 7.40625V6.09375C5.25 5.49219 5.71484 5 6.34375 5H7.65625C8.25781 5 8.75 5.49219 8.75 6.09375V7.40625C8.75 8.03516 8.25781 8.5 7.65625 8.5H6.34375ZM1.09375 1.71875V3.03125H2.40625V1.71875H1.09375ZM0 3.03125V1.71875C0 1.11719 0.464844 0.625 1.09375 0.625H2.40625C3.00781 0.625 3.5 1.11719 3.5 1.71875V3.03125C3.5 3.66016 3.00781 4.125 2.40625 4.125H1.09375C0.464844 4.125 0 3.66016 0 3.03125ZM6.34375 3.03125H7.65625V1.71875H6.34375V3.03125ZM6.34375 4.125C5.71484 4.125 5.25 3.66016 5.25 3.03125V1.71875C5.25 1.11719 5.71484 0.625 6.34375 0.625H7.65625C8.25781 0.625 8.75 1.11719 8.75 1.71875V3.03125C8.75 3.66016 8.25781 4.125 7.65625 4.125H6.34375Z'
                                        fill='#6E7586'
                                      />
                                    </svg>
                                    <p>{productListed.code}</p>
                                    <p>{productListed.name}</p>
                                    <div className='d-flex align-items-center border border-hover-primary rounded m-2'>
                                      <input
                                        className={'border-0 w-100 form-control fw-normal'}
                                        type='number'
                                        value={productListed.qtd ? productListed.qtd : ''}
                                        min={1}
                                        onChange={(event) => {
                                          const newList = [...productsList]
                                          newList.forEach((pd) => {
                                            if (pd.id === productListed.id)
                                              pd.qtd = parseInt(event.target.value)
                                          })
                                          setProductsList(newList)
                                        }}
                                      />
                                    </div>
                                    <i
                                      className='fas fa-trash z-3 cursor-pointer'
                                      onClick={() => removeProduct(productListed)}
                                    ></i>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                </div>
              )}
            </div>
            <div className='d-flex justify-content-end gap-4 p-4'>
              <Button
                text={i18n.t('optional.include')}
                color='primary'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => {
                  showWrapperModal('Adicionar produto')
                }}
                btnClass='fw-bolder'
              />
              <Button
                text={i18n.t('buttons.save')}
                color='primary'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => saveAdditionals()}
                btnClass='fw-bolder'
              />
            </div>
          </div>
          <ModalWrapper
            confirmAction={() => {
              addOptionalItem()
            }}
            noCloseOverlay
            noAction={optionals.filter((op) => op.checked).length <= 0}
          >
            <div
              className='d-flex justify-content-between'
              style={{height: 330, overflowY: 'scroll'}}
            >
              <div className='mx-10 flex-grow-1'>
                <div className={`d-flex flex-row ${styles.searchAdditional}`}>
                  <Input
                    value={query}
                    inputAttr={{
                      type: 'search',
                      name: 'search',
                    }}
                    change={setQuery}
                    placeholder={i18n.t(`buttons.search`)}
                  />
                </div>
                {optionals.some((op) => op.checked) && (
                  <div className='mt-6' style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
                    {optionals.map((op) =>
                      op.checked === true ? (
                        <div
                          style={{
                            color: '#000',
                            backgroundColor: '#f1f2f4',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            minWidth: '30px',
                            minHeight: '30px',
                          }}
                          key={op.id}
                        >
                          <span>{op.name}</span>
                          <div
                            className={styles.closeIcon}
                            onClick={() => {
                              setAtt(true)
                              setIdClick(op.id)
                            }}
                          >
                            <span className={styles.line} />
                            <span className={styles.line} />
                          </div>
                        </div>
                      ) : null
                    )}
                  </div>
                )}
                <div className='row mt-4'>
                  <div className='col-12'>
                    {!att &&
                      searchOptionals.map((item) => (
                        <Input
                          key={`optional-product-${item.id}`}
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={item.checked === true}
                          change={(value: boolean) => {
                            let newOpts = [...optionals]
                            let newSearch = [...searchOptionals]
                            newSearch.forEach((op) => {
                              if (op.id === item.id) op.checked = value
                            })
                            newOpts.forEach((op) => {
                              if (op.id === item.id) op.checked = value
                            })
                            setOptionals(newOpts)
                            setSearchOptionals(newSearch)
                          }}
                          label={`${item.code} - ${item.name}`}
                        />
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </ModalWrapper>
        </div>
      )}
    </>
  )
}

const EditarOpcionais: FC = () => {
  const params = useParams()
  const {type} = params

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: 'Opcionais', path: 'optionals', isActive: true},
        ]}
      >
        {`Editar ${type === 'itens-de-combo' ? 'itens de combo' : type}`}
      </PageTitle>
      <EditarOpcionaisContent />
    </>
  )
}

export {EditarOpcionais}
